/**
 * Free vanilla replacement for GSAP's paid SplitText plugin: wraps a headline's
 * words in masked spans for a translateY reveal, keeping the real text available
 * to screen readers via a visually-hidden duplicate instead of the fragmented spans.
 */
(function () {
  function splitText(el, options) {
    if (!el || el.dataset.splitDone === 'true') return [];
    var by = (options && options.by) || 'word';

    // textContent drops <br> without inserting whitespace, which glues words
    // together across a manual line break ("FOR<br>THE" -> "FORTHE"). Read the
    // text from a clone with every <br> swapped for a space first.
    var clone = el.cloneNode(true);
    clone.querySelectorAll('br').forEach(function (br) { br.replaceWith(' '); });
    var text = clone.textContent.replace(/\s+/g, ' ').trim();

    el.innerHTML = '';

    var srSpan = document.createElement('span');
    srSpan.className = 'sr-only';
    srSpan.textContent = text;
    el.appendChild(srSpan);

    var visual = document.createElement('span');
    visual.setAttribute('aria-hidden', 'true');

    var units = by === 'char' ? text.split('') : text.split(/(\s+)/);
    var targets = [];
    var i = 0;

    units.forEach(function (unit) {
      if (unit.trim() === '') {
        visual.appendChild(document.createTextNode(unit));
        return;
      }
      var mask = document.createElement('span');
      mask.style.cssText = 'display:inline-block;overflow:hidden;vertical-align:top;';
      var inner = document.createElement('span');
      inner.className = 'split-unit';
      inner.style.setProperty('--split-i', i);
      inner.textContent = unit;
      mask.appendChild(inner);
      visual.appendChild(mask);
      targets.push(inner);
      i += 1;
    });

    el.appendChild(visual);
    el.dataset.splitDone = 'true';
    return targets;
  }

  window.ShuttleYard = window.ShuttleYard || {};
  window.ShuttleYard.splitText = splitText;
})();
